import React, { Suspense, lazy } from "react";

import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Loading from "./components/Loading";
import Footer from "./components/Footer";
import ScrollToTop from "./lib/ScrollToTop";
import PageMetadata from "./seo/PageMetadata";
import { routes, validateSiteMetadata } from "./seo/siteMetadata.mjs";

const Home = lazy(() => import(/* webpackChunkName: "Home" */ "./pages/Home"));
const About = lazy(() => import(/* webpackChunkName: "About" */ "./pages/About"));
const Services = lazy(() => import(/* webpackChunkName: "Services" */ "./pages/Services"));
const Work = lazy(() => import(/* webpackChunkName: "Work" */ "./pages/Work"));
const Ventures = lazy(() => import(/* webpackChunkName: "Ventures" */ "./pages/Ventures"));
const Contact = lazy(() => import(/* webpackChunkName: "Contact" */ "./pages/Contact"));
// const Careers = lazy(() => import(/* webpackChunkName: "Careers" */ "./pages/Careers"));
// const JobDetails = lazy(() => import(/* webpackChunkName: "JobDetails" */ "./pages/JobDetails"));
const Privacy = lazy(() => import(/* webpackChunkName: "Privacy" */ "./pages/Privacy"));
const Security = lazy(() => import(/* webpackChunkName: "Security" */ "./pages/Security"));
const Terms = lazy(() => import(/* webpackChunkName: "Terms" */ "./pages/Terms"));

const routeComponents = {
    home: Home,
    about: About,
    services: Services,
    work: Work,
    ventures: Ventures,
    contact: Contact,
    privacy: Privacy,
    security: Security,
    terms: Terms,
};

const metadataErrors = validateSiteMetadata();
if (metadataErrors.length) {
    throw new Error(metadataErrors.join("\n"));
}

function App() {
    return (
        <Router>
            <PageMetadata />
            <ScrollToTop />
            <div className="content">
                <Suspense fallback={<Loading />}>
                    <Switch>
                        {routes.map((route) => {
                            const Page = routeComponents[route.component];
                            return (
                                <Route exact path={route.path} key={route.path}>
                                    <Page />
                                </Route>
                            );
                        })}
                        {/* Careers and job routes remain intentionally unpublished. */}
                        <Route render={() => <Redirect to="/" />} />
                    </Switch>
                </Suspense>
            </div>
            <Footer />
        </Router>
    );
}

export default App;
